var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLive = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 24,
  viewBox: "0 0 22 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#live_svg__filter0_d)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11 0C6.03711 0 2 4.0376 2 9C2 13.9624 6.03711 18 11 18C15.9629 18 20 13.9624 20 9C20 4.0376 15.9629 0 11 0ZM11 17C6.58887 17 3 13.4111 3 9C3 4.58887 6.58887 1 11 1C15.4111 1 19 4.58887 19 9C19 13.4111 15.4111 17 11 17ZM11 4C8.24316 4 6 6.24316 6 9C6 11.7568 8.24316 14 11 14C13.7568 14 16 11.7568 16 9C16 6.24316 13.7568 4 11 4ZM11 13C8.79395 13 7 11.2056 7 9C7 6.79443 8.79395 5 11 5C13.2061 5 15 6.79443 15 9C15 11.2056 13.2061 13 11 13ZM12 9.00012C12 9.55237 11.5522 10.0001 11 10.0001C10.4478 10.0001 10 9.55237 10 9.00012C10 8.44781 10.4478 8.00012 11 8.00012C11.5522 8.00012 12 8.44781 12 9.00012Z",
  fill: "#EC2F2F"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "live_svg__filter0_d",
  x: 0,
  y: 0,
  width: 22,
  height: 24,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})))));
export { SvgLive as ReactComponent };
export default __webpack_public_path__ + "assets/icons/live.2b7b8d.svg";